<style lang="less" scoped>
  .bucket-form{
    .el-form-item{
      margin-bottom: 5px;
    }
  }

  .full-screen-dialog{
    /deep/.el-dialog{
      height: 95vh;
      width: 95vw;
      border-radius: 15px;
      margin: 2.5vh 2.5vw;
    }
    /deep/.el-dialog__header{
      padding: 15px 20px;
      background: linear-gradient(160deg, #26b1bd 20%, #68bce0 80%);
      .el-dialog__title{
        color: white;
      }
      .el-dialog__close{
        font-size: 24px;
        font-weight: bold;
        color: white;
      }
    }
    /deep/.el-dialog__body{
      height: calc(~"95vh - 84px") !important;
      overflow-y: hidden;
      padding: 30px 20px 0;
    }

    /deep/.el-tabs{
      height: 100%;
      display: flex;
      flex-direction: row;
      .el-tabs__content{
        flex: 1;
        .el-tab-pane{height: 100%;}
      }
    }
    .model-list{
      height: 100%;
      overflow-y: auto;
    }
    .record-form{
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }
</style>

<template>
  <el-dialog :title="title" class="full-screen-dialog" :visible.sync="visible" width="800px"
             :fullscreen="true" :before-close="closeDialog" :close-on-click-modal="false" @open="loadBucket">

    <div v-if="bucket" style="height: 100%;">
      <el-tabs value="2" tab-position="left" @tab-click="tabClick">
        <el-tab-pane label="新增模型" name="1">
          <model-save :bucket="bucket.id"></model-save>
        </el-tab-pane>
        <el-tab-pane label="模型列表" name="2">
          <model-list ref="modelList" class="model-list" :bucket-id="bucket.id"></model-list>
        </el-tab-pane>
        <el-tab-pane label="历史调用信息" name="3">
          <record-form class="record-form" :bucket="bucketId"></record-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>
import ModelSave from "@/views/model/save.vue";
import ModelList from "@/views/model/list.vue";
import RecordForm from "./recordForm"

export default {
  components: {
    RecordForm,
    ModelSave,
    ModelList
  },
  props: {
    bucketId: Number,
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bucket: null,
    };
  },
  computed: {
    title() {
      if(this.bucket) {
        return '人脸库模型信息 (' + this.bucket.name + ')' ;
      } else {
        return '人脸库模型信息';
      }
    }
  },
  methods: {
    async loadBucket() {
      if (!this.bucketId) {
        this.closeDialog();
        this.$message.error("缺少人脸库ID");
      }else{
        let bucket = await Vue.store.dispatch("bucket/get", {id: this.bucketId});
        this.bucket = { ...bucket, _expired: "" };
      }
    },
    closeDialog() {
      this.$emit('update:visible', false);
      this.bucket = null;
      this.models = [];
      this.total = 0;
    },
    tabClick(tab, event){
      if(tab.name==="2"){
        this.$refs.modelList.loadModel();
      }
    }
  }
};
</script>

<style>
</style>
